/**
 * Teto de resolução das imagens enviadas nos formulários, aplicado no upload.
 *
 * Ajuste aqui: é o único lugar que define esses números.
 *
 * Por que existe: o navegador decodifica a imagem no tamanho do arquivo, não no tamanho em que ela
 * é exibida — `largura x altura x 4 bytes`. Um arquivo de 15000x15000 ocupa ~858 MB descomprimido
 * mesmo aparecendo num logo de 86px, e foi o que derrubou a geração de PDF por falta de memória.
 *
 * Como os valores foram escolhidos: a folha de impressão tem 900px de largura útil
 * (`.fv2-print` em form-v2-print.svelte). Acima de ~2x isso, o papel não mostra diferença — só
 * custa memória, banda e tempo de PDF. Cada limite é o tamanho impresso multiplicado por essa folga.
 */

/** Logo do cabeçalho — exibido em no máximo 240x86 (ver document-header.svelte), com folga de ~3x. */
export const LOGO_MAX_WIDTH = 720
export const LOGO_MAX_HEIGHT = 260

/** Imagem colada no editor de texto fixo/rico — ocupa até a largura da folha. */
export const CONTENT_IMAGE_MAX_WIDTH = 1600
export const CONTENT_IMAGE_MAX_HEIGHT = 1600

/**
 * Fotos dos blocos "Foto com marcação" e "Antes e depois" — imagem de prontuário (rosto, corpo).
 *
 * Impressas 2 por linha, ~442px = 4,6 polegadas. 1400px já dariam os 300 dpi que o papel resolve;
 * o que manda subir para 2000 é a tela: os dois blocos permitem ampliar até 4x (MAX_ZOOM), e é
 * ampliando que se olha textura de pele, borda de lesão e resultado de procedimento. A 2000px
 * sobra resolução para 2x com nitidez e o papel fica com folga.
 *
 * O custo é pequeno perto do problema que isso resolve: ~12 MB decodificados por foto (4:3) contra
 * os 858 MB de uma imagem em resolução original.
 */
export const PHOTO_MAX_WIDTH = 2000
export const PHOTO_MAX_HEIGHT = 2000

/**
 * Qualidade do JPEG das fotos clínicas, acima do padrão do helper (0.85).
 *
 * Compressão agressiva borra justamente o que dá valor à foto num prontuário — textura e contorno.
 * O arquivo cresce pouco e o detalhe é o que está sendo documentado.
 */
export const PHOTO_QUALITY = 0.92
